var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['c-button', { 'c-button--round': _vm.round }, 'c-button--' + _vm.color],style:({ 'background-color': _vm.bgColor }),attrs:{"type":"button"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }